import React, { useEffect, useState } from "react";
import { Card, Row, Col, message, Button, Table, Spin, Typography, Modal } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import TeamForm from "./TeamForm"; // Import Team Form Component
import { Link } from "react-router-dom";

const { Title } = Typography;

const TeamList = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    fetchTeamMembers();
  }, []);

  const fetchTeamMembers = async () => {
    try {
      setLoading(true);
      const response = await axios.get("http://93.127.203.113:5005/team");
      setTeamMembers(response.data);
    } catch (error) {
      message.error("Failed to fetch team members.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddMember = () => {
    setFormData(null);
    setModalVisible(true);
  };

  const handleEditMember = (record) => {
    setFormData(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`http://93.127.203.113:5005/team/${id}`);
      message.success("Team member deleted successfully");
      fetchTeamMembers();
    } catch (error) {
      message.error("Failed to delete team member.");
    }
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (image) =>
        image ? (
          <img
            src={`http://93.127.203.113:5005${image}`}
            alt="Team Member"
            style={{ width: "50px", height: "50px", borderRadius: "50%" }}
          />
        ) : (
          "No Image"
        ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Job",
      dataIndex: "job",
      key: "job",
    },
    {
      title: <span style={{ fontWeight: "bold", color: "#0c8c49" }}>Actions</span>,
      key: "actions",
      render: (_, record) => (
        <>
          {/* View Details Button */}
          <Button type="link" icon={<InfoCircleOutlined />}>
            <Link to={`/teamDetails/${record.id}`} style={{ color: "#0c8c49" }}>
              Details
            </Link>
          </Button>

          {/* Edit Button */}
          <Button type="link" icon={<EditOutlined />} onClick={() => handleEditMember(record)} style={{ color: "#ffaa00" }}>
            Edit
          </Button>

          {/* Delete Button */}
          <Button type="link" icon={<DeleteOutlined />} onClick={() => handleDelete(record.id)} danger>
            Delete
          </Button>
        </>
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>Team Members</Title>

        {/* Add Team Member Button */}
        <Row justify="end" style={{ marginBottom: "20px" }}>
          <Button type="primary" icon={<PlusOutlined />} onClick={handleAddMember} style={{ backgroundColor: "#0c8c49", borderColor: "#0c8c49" }}>
            Add Team Member
          </Button>
        </Row>

        {loading ? <Spin size="large" /> : <Table columns={columns} dataSource={teamMembers} rowKey="id" />}

      </Card>

      {/* Modal for Team Form */}
      <Modal
        title={formData ? "Edit Team Member" : "Add Team Member"}
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        destroyOnClose
      >
        <TeamForm formData={formData} setFormData={setFormData} closeModal={() => setModalVisible(false)} refetchData={fetchTeamMembers} />
      </Modal>
    </div>
  );
};

export default TeamList;
